import React, { FC } from 'react';
import { Box, Button, Typography } from '@mui/material';
import logo_vrt from '../../images/logo_vrt.png';

interface OnboardingWelcomeProps {
  onNext: () => void;
}

export const OnboardingWelcome: FC<OnboardingWelcomeProps> = ({ onNext }) => {
  return (
    <Box sx={{ width: '100%', paddingX: '5vw' }}>
      <Box
        sx={{
          width: '100%',
          marginTop: '20vh',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <img src={logo_vrt} height={'100px'} />
      </Box>
      <Box
        sx={{
          width: '100%',
          marginY: '7vh',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Typography variant="h5" sx={{ textAlign: 'center', marginY: '2%' }}>
          Regístrate para acceder a Makana siempre que lo necesites!
        </Typography>
      </Box>
      <Button
        onClick={onNext}
        size="large"
        sx={{
          width: '100%',
          marginY: '2%',
          fontWeight: 'bold',
          borderRadius: '50px',
        }}
        variant="contained"
      >
        EMPEZAR MI REGISTRO
      </Button>
    </Box>
  );
};
